// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DO NOT TOUCH :) */

.footer {
  background-color: #6b6960;
  padding: 1.2rem 0;
  color: rgb(190, 190, 190);
  text-align: center;
  font-size: 15px;
  width: 100%;
}

.footer-container {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-grow: 1;  
}

.separator {
  height: 4.5rem; 
  background-color: #ffffff;
  border-left: 0.25px dotted #ffffff;
}

.institution-logo {
  height: 85px;
  width: auto;
  margin: 0 10px;
}

.logo-with-social {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.social-logo {
  height: 24px;
  width: auto;
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/footer.css"],"names":[],"mappings":"AAAA,oBAAoB;;AAEpB;EACE,yBAAyB;EACzB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB","sourcesContent":["/* DO NOT TOUCH :) */\n\n.footer {\n  background-color: #6b6960;\n  padding: 1.2rem 0;\n  color: rgb(190, 190, 190);\n  text-align: center;\n  font-size: 15px;\n  width: 100%;\n}\n\n.footer-container {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  flex-grow: 1;  \n}\n\n.separator {\n  height: 4.5rem; \n  background-color: #ffffff;\n  border-left: 0.25px dotted #ffffff;\n}\n\n.institution-logo {\n  height: 85px;\n  width: auto;\n  margin: 0 10px;\n}\n\n.logo-with-social {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.social-logo {\n  height: 24px;\n  width: auto;\n  margin-top: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
